import { useCallback } from 'react'
import { AllowedPatientTypes } from '@customTypes/Patient'
import { PatientTypeOptions } from 'src/config/patientTypeOptions'
import { analyticsEventSelectedPatient } from 'src/services/analytics'
import { setPatientType, resetSelectedBookable, useChoiceDispatch, useChoiceState } from '@context/ChoiceContext'
import {
  clearPractitioners,
  resetSelectedPractitionersFor,
  usePractitionersDispatch,
} from '@context/PractitionersContext'

export const useSelectPatientType = (onNextClicked?: (type: PatientTypeOptions) => void) => {
  const choiceDispatch = useChoiceDispatch()
  const practitionersDispatch = usePractitionersDispatch()
  const { patientType } = useChoiceState()

  const handleSelect = useCallback(
    (type: AllowedPatientTypes) => {
      choiceDispatch(setPatientType(type))
      if (type !== patientType) {
        choiceDispatch(resetSelectedBookable())
        practitionersDispatch(clearPractitioners())
        practitionersDispatch(resetSelectedPractitionersFor())
      }
      analyticsEventSelectedPatient(type === PatientTypeOptions.OLD)
      onNextClicked?.(type)
    },
    [choiceDispatch, onNextClicked, practitionersDispatch, patientType]
  )

  return handleSelect
}
